import notification from 'antd/es/notification';
import 'antd/es/notification/style/css';

export default notification;
